import React, { useState, useEffect } from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { motion } from 'framer-motion';

const EconomicTicker = () => {
  const [tickerData, setTickerData] = useState([]);

  // Données économiques et minières pour RDC, Congo Brazzaville et Angola
  const generateTickerData = () => {
    return [
      // Produits miniers RDC
      { symbol: 'COBALT-DRC', name: 'Cobalt', price: 32.45, change: 2.3, unit: 'USD/lb', country: 'RDC', type: 'mineral', icon: '⛏️' },
      { symbol: 'COPPER-DRC', name: 'Cuivre', price: 8945.20, change: -0.8, unit: 'USD/t', country: 'RDC', type: 'mineral', icon: '🔶' },
      { symbol: 'GOLD-DRC', name: 'Or', price: 2048.75, change: 1.2, unit: 'USD/oz', country: 'RDC', type: 'mineral', icon: '🥇' },
      { symbol: 'DIAMOND-DRC', name: 'Diamant', price: 156.80, change: 0.5, unit: 'USD/ct', country: 'RDC', type: 'mineral', icon: '💎' },
      { symbol: 'COLTAN-DRC', name: 'Coltan', price: 142.30, change: 3.1, unit: 'USD/kg', country: 'RDC', type: 'mineral', icon: '⚫' },
      { symbol: 'ZINC-DRC', name: 'Zinc', price: 2685.50, change: 1.5, unit: 'USD/t', country: 'RDC', type: 'mineral', icon: '⚪' },
      
      // Produits miniers Congo Brazzaville
      { symbol: 'OIL-CGB', name: 'Pétrole', price: 84.32, change: -1.2, unit: 'USD/bbl', country: 'CGB', type: 'mineral', icon: '🛢️' },
      { symbol: 'POTASH-CGB', name: 'Potasse', price: 285.50, change: 0.9, unit: 'USD/t', country: 'CGB', type: 'mineral', icon: '🧂' },
      { symbol: 'GAS-CGB', name: 'Gaz Naturel', price: 3.45, change: 2.1, unit: 'USD/MMBtu', country: 'CGB', type: 'mineral', icon: '🔥' },
      
      // Produits miniers Angola
      { symbol: 'OIL-AGO', name: 'Pétrole Brut', price: 83.95, change: -1.1, unit: 'USD/bbl', country: 'AGO', type: 'mineral', icon: '🛢️' },
      { symbol: 'DIAMOND-AGO', name: 'Diamant', price: 168.45, change: 1.8, unit: 'USD/ct', country: 'AGO', type: 'mineral', icon: '💎' },
      { symbol: 'IRON-AGO', name: 'Fer', price: 112.30, change: -0.3, unit: 'USD/t', country: 'AGO', type: 'mineral', icon: '🔩' },
      
      // === INDICATEURS ÉCONOMIQUES RDC ===
      { symbol: 'CDF/USD', name: 'Taux de Change', price: 2850.00, change: 0.2, unit: 'CDF', country: 'RDC', type: 'forex', icon: '💱' },
      { symbol: 'GDP-DRC', name: 'PIB (Croissance)', price: 7.2, change: 0.5, unit: '%', country: 'RDC', type: 'indicator', icon: '📈' },
      { symbol: 'INF-DRC', name: 'Inflation', price: 8.5, change: -0.3, unit: '%', country: 'RDC', type: 'indicator', icon: '💹' },
      { symbol: 'RATE-DRC', name: 'Taux Directeur', price: 8.0, change: 0.0, unit: '%', country: 'RDC', type: 'indicator', icon: '🏦' },
      { symbol: 'DEBT-DRC', name: 'Dette Publique', price: 18.5, change: -0.5, unit: '% PIB', country: 'RDC', type: 'indicator', icon: '📊' },
      { symbol: 'UNEMP-DRC', name: 'Chômage', price: 42.3, change: -1.2, unit: '%', country: 'RDC', type: 'indicator', icon: '👥' },
      { symbol: 'TRADE-DRC', name: 'Balance Comm.', price: 2.8, change: 1.5, unit: 'Mrd USD', country: 'RDC', type: 'indicator', icon: '🚢' },
      { symbol: 'FDI-DRC', name: 'Invest. Étrangers', price: 3.2, change: 5.8, unit: 'Mrd USD', country: 'RDC', type: 'indicator', icon: '💼' },
      { symbol: 'RES-DRC', name: 'Réserves Change', price: 4.5, change: 2.1, unit: 'Mrd USD', country: 'RDC', type: 'indicator', icon: '💰' },
      
      // === INDICATEURS ÉCONOMIQUES CONGO BRAZZAVILLE ===
      { symbol: 'XAF/USD', name: 'Taux de Change', price: 615.20, change: 0.1, unit: 'XAF', country: 'CGB', type: 'forex', icon: '💱' },
      { symbol: 'GDP-CGB', name: 'PIB (Croissance)', price: 5.8, change: 0.4, unit: '%', country: 'CGB', type: 'indicator', icon: '📈' },
      { symbol: 'INF-CGB', name: 'Inflation', price: 4.2, change: -0.2, unit: '%', country: 'CGB', type: 'indicator', icon: '💹' },
      { symbol: 'OIL-PROD-CGB', name: 'Production Pétrole', price: 265.0, change: -2.1, unit: 'K bbl/j', country: 'CGB', type: 'indicator', icon: '🛢️' },
      { symbol: 'DEBT-CGB', name: 'Dette Publique', price: 88.5, change: 1.2, unit: '% PIB', country: 'CGB', type: 'indicator', icon: '📊' },
      { symbol: 'TRADE-CGB', name: 'Balance Comm.', price: 1.2, change: -0.8, unit: 'Mrd USD', country: 'CGB', type: 'indicator', icon: '🚢' },
      { symbol: 'RES-CGB', name: 'Réserves Change', price: 1.8, change: 0.5, unit: 'Mrd USD', country: 'CGB', type: 'indicator', icon: '💰' },
      
      // === INDICATEURS ÉCONOMIQUES ANGOLA ===
      { symbol: 'AOA/USD', name: 'Taux de Change', price: 825.50, change: 0.3, unit: 'AOA', country: 'AGO', type: 'forex', icon: '💱' },
      { symbol: 'GDP-AGO', name: 'PIB (Croissance)', price: 4.5, change: 0.6, unit: '%', country: 'AGO', type: 'indicator', icon: '📈' },
      { symbol: 'INF-AGO', name: 'Inflation', price: 12.8, change: -0.5, unit: '%', country: 'AGO', type: 'indicator', icon: '💹' },
      { symbol: 'OIL-PROD-AGO', name: 'Production Pétrole', price: 1145.0, change: 1.8, unit: 'K bbl/j', country: 'AGO', type: 'indicator', icon: '🛢️' },
      { symbol: 'DEBT-AGO', name: 'Dette Publique', price: 95.2, change: -2.3, unit: '% PIB', country: 'AGO', type: 'indicator', icon: '📊' },
      { symbol: 'UNEMP-AGO', name: 'Chômage', price: 32.5, change: -0.8, unit: '%', country: 'AGO', type: 'indicator', icon: '👥' },
      { symbol: 'TRADE-AGO', name: 'Balance Comm.', price: 8.5, change: 3.2, unit: 'Mrd USD', country: 'AGO', type: 'indicator', icon: '🚢' },
      { symbol: 'RES-AGO', name: 'Réserves Change', price: 12.3, change: 1.9, unit: 'Mrd USD', country: 'AGO', type: 'indicator', icon: '💰' },
      
      // === INDICATEURS MONDIAUX DE RÉFÉRENCE ===
      { symbol: 'WTI', name: 'Pétrole WTI', price: 78.45, change: -0.9, unit: 'USD/bbl', country: 'WORLD', type: 'commodity', icon: '🌍' },
      { symbol: 'BRENT', name: 'Pétrole Brent', price: 82.30, change: -0.7, unit: 'USD/bbl', country: 'WORLD', type: 'commodity', icon: '🌍' },
      { symbol: 'EUR/USD', name: 'Euro/Dollar', price: 1.0845, change: 0.15, unit: '', country: 'WORLD', type: 'forex', icon: '💶' },
    ];
  };

  useEffect(() => {
    // Initialiser les données
    setTickerData(generateTickerData());

    // Mettre à jour les données toutes les 10 secondes avec de petites variations
    const interval = setInterval(() => {
      setTickerData(prevData => 
        prevData.map(item => ({
          ...item,
          price: item.price + (Math.random() - 0.5) * (item.price * 0.01),
          change: (Math.random() - 0.5) * 4
        }))
      );
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const getChangeIcon = (change) => {
    if (change > 0) return <TrendingUp className="w-3 h-3" />;
    if (change < 0) return <TrendingDown className="w-3 h-3" />;
    return <Minus className="w-3 h-3" />;
  };

  const getChangeColor = (change) => {
    if (change > 0) return 'text-green-400';
    if (change < 0) return 'text-red-400';
    return 'text-gray-400';
  };

  const getCountryBadge = (country) => {
    const badges = {
      'RDC': { bg: 'bg-blue-500', text: 'RDC' },
      'CGB': { bg: 'bg-green-500', text: 'CGB' },
      'AGO': { bg: 'bg-red-500', text: 'AGO' },
      'WORLD': { bg: 'bg-purple-500', text: 'INT' }
    };
    return badges[country] || badges['RDC'];
  };

  return (
    <div className="bg-gradient-to-r from-[#1B325F] via-[#243a6f] to-[#1B325F] border-y-2 border-[#DB242C]/30 shadow-lg overflow-hidden relative">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>

      {/* Live indicator */}
      <div className="absolute left-4 top-1/2 transform -translate-y-1/2 flex items-center space-x-2 z-10">
        <div className="flex items-center space-x-2 bg-red-500/20 backdrop-blur-sm px-3 py-1 rounded-full border border-red-500/30">
          <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
          <span className="text-white text-xs font-semibold uppercase tracking-wider">LIVE</span>
        </div>
      </div>

      {/* Scrolling ticker */}
      <div className="relative py-2.5 pl-24">
        <motion.div
          className="flex space-x-8"
          animate={{
            x: [0, -2000],
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 60,
              ease: "linear",
            },
          }}
        >
          {/* Duplicate the data twice for seamless loop */}
          {[...tickerData, ...tickerData, ...tickerData].map((item, index) => (
            <div
              key={`${item.symbol}-${index}`}
              className="flex items-center space-x-3 bg-white/5 backdrop-blur-sm px-4 py-1.5 rounded-lg border border-white/10 hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
            >
              {/* Country badge */}
              <span className={`${getCountryBadge(item.country).bg} text-white text-[10px] font-bold px-2 py-0.5 rounded`}>
                {getCountryBadge(item.country).text}
              </span>

              {/* Icon */}
              {item.icon && (
                <span className="text-base">
                  {item.icon}
                </span>
              )}

              {/* Symbol */}
              <span className="text-white font-bold text-sm">
                {item.symbol}
              </span>

              {/* Name */}
              <span className="text-gray-300 text-xs hidden lg:inline">
                {item.name}
              </span>

              {/* Price */}
              <span className="text-white font-semibold text-sm">
                {item.price.toFixed(2)} {item.unit}
              </span>

              {/* Change */}
              <div className={`flex items-center space-x-1 ${getChangeColor(item.change)}`}>
                {getChangeIcon(item.change)}
                <span className="text-xs font-medium">
                  {item.change > 0 ? '+' : ''}{item.change.toFixed(2)}%
                </span>
              </div>
            </div>
          ))}
        </motion.div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#1B325F] to-transparent pointer-events-none"></div>
    </div>
  );
};

export default EconomicTicker;
